import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { formatDataPoints } from "@/data.functions";
import { ServiceResult } from "@/data.types";

interface Props {
  data: ServiceResult
}

export default /*#__PURE__*/_defineComponent({
  __name: 'telemetry-graphic',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ServiceResult
};



const propellant = computed(() => {
  return formatDataPoints([
    ["CITP_ServiceFuelRemain", "service"],
    ["CITP_CrewFuelRemain", "crew"],
    ["CITP_TotalFuelRemain", "total"]
  ], props.data)
})

const batteries = computed(() => {
  return formatDataPoints([
    ["CITP_BatC1aSOC", "c1a_pct"],
    ["CITP_BatC1aVolt", "c1a_volt"],
    ["CITP_BatC1bSOC", "c1b_pct"],
    ["CITP_BatC1bVolt", "c1b_volt"],
    ["CITP_BatC2aSOC", "c2a_pct"],
    ["CITP_BatC2aVolt", "c2a_volt"],
    ["CITP_BatC2bSOC", "c2b_pct"],
    ["CITP_BatC2bVolt", "c2b_volt"]
  ], props.data)
})

const cabin = computed(() => {
  return formatDataPoints([
    ["CITP_TotNitOnb", "water"],
    ["CITP_CabPress", "pressure"],
    ["CITP_CabTemp_Avg", "temp_avg"],
    ["CITP_CabTemp_Zone1", "temp_1"],
    ["CITP_CabTemp_Zone2", "temp_2"],
    ["CITP_CabTemp_Zone3", "temp_3"],
  ], props.data)
})

const orion = computed(() => {
  return formatDataPoints([
    ["CITP_OrnSpinSpeed", "spin_rate"],
  ], props.data)
})

const power = computed(() => {
  return formatDataPoints([
    ["CITP_PS1A", "string1a"],
    ["CITP_PS1B", "string1b"],
    ["CITP_PS2A", "string2a"],
    ["CITP_PS2B", "string2b"],
  ], props.data)
})

const solar_array = computed(() => {
  return formatDataPoints([
    ["CITP_ExtTemp_Wing_1", "temp_1"],
    ["CITP_ExtTemp_Wing_2", "temp_2"],
    ["CITP_ExtTemp_Wing_3", "temp_3"],
    ["CITP_ExtTemp_Wing_4", "temp_4"],
  ], props.data)
})

return { __sfc: true,props, propellant, batteries, cabin, orion, power, solar_array }
}

})